import { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  IconButton,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useQuery } from "@apollo/client";
import { GET_MEMBER_DETAILS } from "../graphql/queries";
import TKSMemberCard from "./TKSMemberCard";
import NotLoggedIn from "../components/LoginExceptions";

const MembershipIDCard = () => {
  const [mobile, setMobile] = useState("");
  const navigate = useNavigate();
  const { user } = useAuth();
  const cardRef = useRef(null);
  const storedUserType = localStorage.getItem("user_type");




  useEffect(() => {
    const storedMobile = localStorage.getItem("mobile");
    if (storedMobile) setMobile(storedMobile);
  }, []);

  const { loading, error, data } = useQuery(GET_MEMBER_DETAILS, {
    variables: { mobile },
    skip: !mobile,
  });

  if (loading) return <CircularProgress />;
  if (error) return <p>Error: {error.message}</p>;
  if (!data?.member) return <p>No data found</p>;


  if (!storedUserType) {
    return <NotLoggedIn />;
  }

  const member = data.member;
  const storedUser = localStorage.getItem("first_name");

  const mandatoryFields = [
    "Family_Details",
    "Email",
    "Occupation",
    "Address",
    "Marital_Status",
    "ID_Proof_Type",
    "ID_Proof_Number",
  ];

  const isDataIncomplete = mandatoryFields.some(
    (field) => !member[field] || member[field] === ""
  );

  const isPanCardNo = member?.Pan_Card === "No";
  const isPanDetailsMissing =
    isPanCardNo && (!member?.Pan_Number || member?.Pan_Number === "");

  const isPaymentPending = member?.Payment_Status !== "Paid";

  const handleDownload = async () => {
    const element = cardRef.current;
    const canvas = await html2canvas(element, { scale: 3 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [92, 60],
    });
    pdf.addImage(imgData, "PNG", 0, 0, 92, 60);
    pdf.save("Membership_ID_Card.pdf");
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f4f4f4"
      p={{ xs: 2, sm: 3 }}
      sx={{ backgroundColor: "#f8f9e9", py: 12, minHeight: "500px" }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: "500",
          color: "#2A289C",
          textAlign: "center",
          fontSize: "32px",
        }}
        gutterBottom
      >
        Membership ID Card
      </Typography>

      {isDataIncomplete ? (
        <Typography variant="body1" color="#7A7841" textAlign="center">
          You're almost there {storedUser}! To obtain your official Membership ID Card,
          please complete your profile.<br />
          This helps us verify your details and provide full access to membership benefits.{" "}
          <Typography
            component="span"
            sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
            onClick={() => {
              navigate("/profile");
              window.scrollTo(0, 0);
            }}
          >
            Click here
          </Typography>{" "}
          to navigate to your user profile.
        </Typography>
      ) : isPanDetailsMissing ? (
        <Typography variant="body1" color="#7A7841" textAlign="center">
          You're almost there {storedUser}! To obtain your official Membership ID Card,
          please provide your PAN Number in your profile.<br />
          This helps us verify your details and provide full access to membership benefits.{" "}
          <Typography
            component="span"
            sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
            onClick={() => {
              navigate("/profile");
              window.scrollTo(0, 0);
            }}
          >
            Click here
          </Typography>{" "}
          to navigate to your user profile.
        </Typography>
      ) : isPaymentPending ? (
        <Typography variant="body1" color="#7A7841" textAlign="center">
          You're just one step away {storedUser}! To obtain your official Membership ID Card,
          please make <br /> a one-time payment of ₹2000.
          <br />
          <strong>Your current payment status is {member.Payment_Status}</strong>
          <br />
          <br />
          <Typography
            component="span"
            sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
            onClick={() => {
              navigate("/paymentgateway");
              window.scrollTo(0, 0);
            }}
          >
            Click here
          </Typography>{" "}
          to proceed with the payment.
        </Typography>
      ) : (
        <Card
          sx={{
            mt: 4,
            width: "fit-content",
            p: 2,
            backgroundColor: "#fff",
            borderRadius: 3,
            position: "relative",
            boxShadow: 4,
          }}
        >
          {/* Top-right download button */}
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Button

              color="black"
              size="small"
              startIcon={<DownloadIcon />}
              onClick={handleDownload}
            >
              Download
            </Button>
          </Box>

          {/* Member Card */}
          <Box ref={cardRef} display="flex" justifyContent="center" mt={4}>
            <TKSMemberCard member={member} />
          </Box>
        </Card>
      )}

      <Box mt={4}>
        <Button
          variant="contained"
          href="/"
          sx={{
            backgroundColor: "#2A289C",
            color: "#fff",
            '&:hover': {
              backgroundColor: "#1a1970",
            },
          }}
        >
          Back to Homepage
        </Button>

      </Box>
    </Box>
  );
};
export default MembershipIDCard;